import { Icon } from "components/icon/Icon";

import "./Loader.scss";

export function Loader({ label = "", className = "", ...rest }) {
  return (
    <div className={`loader ${className}`} {...rest}>
      <Icon name="circle-o-notch" spin />
      {label && <div className="ml-3">{label}</div>}
    </div>
  );
}
